// extracted by mini-css-extract-plugin
export default {"btn":"N8Fou","btn-spinner":"_8jMzH"};